export function setDragging(val, draggingKeys) {
  // List of keys to exclude from the object
  const excludes = [
    'pallete',
    'isGradient',
    'city',
    'province',
    'country',
    'socialMedia',
    'center',
    'coordinates',
    'address',
    'apiKey',
    'companyNumber',
    'companyNumberName',
    'visitName',
    'organizationName',
    'subOrgan',
    'VideoGallery',
    'customerClub',
    'shopLoginConfig',
    'advanceSettings'
  ];

  // Create a copy of the input object and remove excluded keys
  const obj = {...val};
  excludes.forEach(key => delete obj[key]);

  // Get the current dragging keys
  let dk = draggingKeys.map(item => item.name);

  // Array to store keys that need to be removed
  const toBeRemoved = [];

  // Function to remove an item from the dragging keys
  const removeItem = (item) => {
    const index = dk.findIndex(r => r === item);
    if (index !== -1) {
      dk.splice(index, 1);
    }
  };

  // Iterate over the remaining keys in the object
  Object.keys(obj).forEach((item) => {
    // Check conditions for removing specific keys
    if (!val[item]) {
      toBeRemoved.push(item);
    } else if (item === 'video_single' && (!obj[item]?.videos || !obj[item].videos.length)) {
      toBeRemoved.push(item);
    } else if (item === 'video_gallery' && obj[item].every(e => !e?.images?.length)) {
      toBeRemoved.push(item);
    } else if (item === 'photo' && obj[item]?.gallery?.every(e => !e?.images?.length)) {
      toBeRemoved.push(item);
    } else if (item === 'extraFields' && obj[item].every(e => !e.name && !e.icon && !e.value)) {
      toBeRemoved.push(item);
    } else if (item === 'phoneNumber' && !obj[item].filter(e => e?.number).length) {
      toBeRemoved.push(item);
    } else if (!dk.includes(item)) {
      dk.push(item);
    }
  });

  // Remove items marked for removal
  toBeRemoved.forEach(item => removeItem(item));

  // Update draggingKeys with unique values
  return Array.from(new Set(dk)).map(item => ({name: item}));
}
